export const rawStyles = {
  fixedWidth: {
    width: 150,
    height: 80,
    borderColor: 'red',
    borderWidth: 1.5,
    backgroundColor: '#FFFFFF33',
    flexDirection: 'column' as const,
  },
  titleContainer: {
    borderBottomColor: 'red',
    borderBottomWidth: 0.5,

    alignItems: 'center' as const,
    padding: 5,
  },
  red: {
    fontSize: 10,
    fontWeight: 'bold',
    color: 'red',
  },
  grey: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#605e5c',
  },
  rowContainer: {
    borderBottomColor: 'red',
    borderBottomWidth: 0.5,
    justifyContent: 'space-between' as const,
    alignItems: 'center' as const,
    padding: 5,
    flexDirection: 'row' as const,
  },
  container: {
    justifyContent: 'space-between' as const,
    alignItems: 'center' as const,
    padding: 5,
    flexDirection: 'row' as const,
  },
};
